module.exports = __webpack_public_path__ + "img/supplier-pc.227334b.png";